import { AccordionInput } from './accordion-input.model';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-shared-accordion',
	templateUrl: './accordion.component.html',
	styleUrls: ['./accordion.component.styl'],
	encapsulation: ViewEncapsulation.None
})

export class SharedAccordionComponent implements OnInit {
	@Input() accordionList: Array<AccordionInput> = [];

	step: number = 0;

	constructor() { }

	ngOnInit() {}

	setStep(index: number) {
		this.step = index;
	}

	nextStep() {
		this.step++;
	}

	keepStepOpened(index: number) {
		if (this.step === index && this.step !== this.accordionList.length) {
			this.nextStep();
		} else {
			return;
		}
	}

}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/accordion/accordion.component.ts